import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PropertiesPage from "./pages/PropertiesPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import ContactPage from "./pages/ContactPage";
import Shell from "./components/Shell";

function NotFound(): JSX.Element {
    return (
        <div className="space-y-4">
            <h1 className="text-2xl font-semibold tracking-tight">Not Found</h1>
            <p className="text-sm text-[rgb(var(--muted))]">
                The requested page does not exist.
            </p>
        </div>
    );
}

export default function App(): JSX.Element {
    return (
        <Shell>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/properties" element={<PropertiesPage />} />
                <Route
                    path="/properties/:id"
                    element={<PropertyDetailPage />}
                />
                <Route
                    path="/p/:shortId"
                    element={<PropertyDetailPage standalone={true} />}
                />
                <Route path="/p" element={<NotFound />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Shell>
    );
}
